import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function paginationReducers(
  state = initialState.pagination,
  action
) {
  if (action.type === types.LOAD_PAGINATION_DATA_SUCCESS) {
    return action.pagination;
  }
  return state;
}
